module.exports = __webpack_public_path__ + "img/RedteaSIM_ZH03.80e3814e.jpg";